/**
 * RealtimeHub WebSocket 连接鉴权参数。
 *
 * 浏览器 WebSocket 无法设置自定义 HTTP Header；@comein/ws-lib 通过 `params`
 * 将鉴权信息拼接到连接 URL，字段与 jmHttp 请求头中的 token / web_token 保持一致。
 *
 * @module utils/realtime/wsConnectOptions
 */

import { LOCAL_STORAGE_KEY } from '@/constants';
import { getStorageAuthInfo } from '@/utils/storageOperateApi';

/**
 * 读取与 jmHttp 拦截器相同的 token 值。
 * @returns {string}
 */
export function getRealtimeWsToken() {
  const userInfo = getStorageAuthInfo(LOCAL_STORAGE_KEY.JM_AUTH_INFO) || {};
  return userInfo.webtoken || userInfo.token || '';
}

/**
 * 生成 ws-lib 连接用的 query 参数
 * @returns {Record<string, string>}
 */
export function getRealtimeWsConnectParams() {
  const token = getRealtimeWsToken();
  if (!token) {
    return {};
  }
  return {
    token,
    clientType: 1
  };
}

/**
 * 每次建立 WebSocket 前解析的 WsSharedClient 选项。
 * @returns {import('@comein/ws-lib').WsSharedOptions}
 */
export function resolveRealtimeWsClientOptions() {
  return {
    params: getRealtimeWsConnectParams()
  };
}
